import { ERROR_TOAST } from "../../constants/toast.constants";
import { globalConstants, paymentHistoryConstants } from "../../constants";
import { custom, success } from "./utilities";
import { customToast } from "../../shared/utility";
import { paymentHistoryService } from "../../services";

const { GET_PAYMENT_HISTORY, PAYMENT_HISTORY_PAGINATION } =
  paymentHistoryConstants;

const getPaymentHistory = (data) => (dispatch) => {
  dispatch(custom(GET_PAYMENT_HISTORY, globalConstants.SPINNER_ACTIVATE));
  return paymentHistoryService
    .getPaymentHistory(data)
    .then(
      (response) => dispatch(success(response.data, GET_PAYMENT_HISTORY)),
      (error) => customToast(error[0], ERROR_TOAST)
    )
    .finally(() =>
      dispatch(custom(GET_PAYMENT_HISTORY, globalConstants.SPINNER_DIACTIVATE))
    );
};

const updatePagination = (data) => (dispatch) =>
  dispatch(custom(data, PAYMENT_HISTORY_PAGINATION));

export const paymentHistoryActions = {
  getPaymentHistory,
  updatePagination,
};
